import { IRegionInfo } from '../selectGeocodeSuggestion';
import {
  IGeocodedForSearchResponseItemDetailSchema,
} from '@cian/api-models/monolith-csharp/api/geo/geocoded-for-search';

export const getRegionInfo = (locationsList: IGeocodedForSearchResponseItemDetailSchema[]) => {
  return (
    locationsList.reduce(
      (prevValue: IRegionInfo, currentValue: IRegionInfo) => {
        if (currentValue && currentValue.locationInfo) {
          return currentValue;
        }

        return prevValue;
      },
      undefined,
    )
  );
};
